import { Box, Card, CardContent, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { DND_COLORS, DND_OPACITY } from '@/components/dnd';

export const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'grab',
  border: `1px solid ${theme.palette.divider}`,
  transition: 'opacity 0.15s ease, outline 0.15s ease, background-color 0.15s ease',
  '&[data-dnd-dragging="true"]': {
    opacity: DND_OPACITY.dragging,
  },
  '&[data-dnd-drop-target="true"]': {
    backgroundColor: DND_COLORS.dropTargetBackground,
    outline: `2px solid ${DND_COLORS.dropTargetPrimary}`,
    outlineOffset: '-2px',
  },
}));

export const MediaArea = styled(Box)(({ theme }) => ({
  height: 180,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
  position: 'relative',
}));

export const StyledCardContent = styled(CardContent)({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  padding: 12,
  '&:last-child': {
    paddingBottom: 12,
  },
});

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const ThumbnailLink = styled(StyledLink)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const InlineLink = styled(StyledLink)({
  display: 'inline',
});
